import React from "react";
import * as styles from "./spotify-player.module.css";

const spotifySrc =
  "https://open.spotify.com/embed/album/6LwFciRrX9LteAJXEohyv6?utm_source=generator";

const SpotifyPlayer = () => (
  <iframe
    width="100%"
    height="352"
    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    loading="lazy"
    src={spotifySrc}
    className={styles.spotifyEmbedPlayer}
  ></iframe>
);

export default SpotifyPlayer;
